import { Component, OnInit, ViewChild } from '@angular/core';
import { MatPaginator } from '@angular/material/paginator';
import { MatDrawerContainer } from '@angular/material/sidenav';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { MigrationService } from 'src/app/_services/document-migration.services';
@Component({
  selector: 'app-reports',
  templateUrl: './report.component.html',
  styleUrls: ['./report.component.scss']
})
export class ReportComponent implements OnInit {
  
  loadPrevious:boolean = false;
  loadNext:boolean = false;
  loadTeamPrevious:boolean = false;
  loadTeamNext:boolean = false;
  selectedRow: Array<JSON> = [];
  userReportList: MatTableDataSource<any>;
  teamReportList: MatTableDataSource<any>;
  userSort;
  userCount: number = 0;
  teamCount: number = 0;
  offset: number = 0;
  teamOffset: number = 0;
  users: any;
  teams: any;
  totalUserCount: number = 0;
  totalTeamCount: number = 0;
  userCols: String[] = ["Users", "upload", "index", "duplicate", "export"];
  teamsCols: String[] = ["Teams",  "upload", "index", "duplicate", "export"];
  userfilterInput: string = "";
  teamfilterInput: string = "";

  @ViewChild(MatDrawerContainer) userDrawerContainer: MatDrawerContainer;
  @ViewChild(MatSort, { static: false }) set userContent(content: any) {
    this.userSort = content;
    if (this.userSort && this.userReportList) {
      this.userReportList.sort = this.userSort;
    }
  }

  @ViewChild('userPaginator', { static: false }) userPaginator: MatPaginator;
  set pageUserContent(content: any) {
    this.userPaginator = content;
    if (this.userPaginator && this.userReportList) {
      this.userReportList.paginator = this.userPaginator;
    }
  }

  teamSort;

  @ViewChild(MatDrawerContainer) teamDrawerContainer: MatDrawerContainer;
  @ViewChild(MatSort, { static: false }) set content(content: any) {
    this.teamSort = content;
    if (this.teamSort && this.teamReportList) {
      this.teamReportList.sort = this.teamSort;
    }
  }

  @ViewChild('teamPaginator', { static: false }) teamPaginator: MatPaginator;
  set pageTeamContent(content: any) {
    this.teamPaginator = content;
    if (this.teamPaginator && this.teamReportList) {
      this.teamReportList.paginator = this.teamPaginator;
    }
  }

  constructor(
    private migrationService: MigrationService,
  ) {

  }

  ngOnInit() {    
    this.loadUserTable();    
    this.loadTeamTable();
  }

  applyUserFilter() {
    let filterValue = this.userfilterInput.trim().toLowerCase();
    this.userReportList.filter = filterValue.trim().toLowerCase();
    if (this.userReportList.paginator) {
      this.userReportList.paginator.firstPage();
      this.userCount = this.userReportList.filteredData.length;
    }
  }

  applyTeamFilter() {
    let filterValue = this.teamfilterInput.trim().toLowerCase();
    this.teamReportList.filter = filterValue.trim().toLowerCase();
    if (this.teamReportList.paginator) {
      this.teamReportList.paginator.firstPage();
      this.teamCount = this.teamReportList.filteredData.length;
    }
  }


  next() {
    this.offset = this.offset + 200;
  }

  previous() {
    this.offset = this.offset - 200;
  }

  teamNext() {
    this.teamOffset = this.teamOffset + 200;
  }

  teamPrevious() {
    this.teamOffset = this.teamOffset - 200;
  }

  loadUserTable() {
    this.migrationService.getReport().subscribe(users => {
      this.users = users;
      this.totalUserCount = users.count;
      if (this.totalUserCount > this.offset + 200) {
        this.loadNext = true;
      }
      if (this.offset >= 200) {
        this.loadPrevious = true;
      }
      this.userCount = this.users.length;
      this.userReportList = new MatTableDataSource(this.users);
      this.userReportList.sort = this.userSort;
      this.userReportList.paginator = this.userPaginator;
    });
  }

  loadTeamTable() {
    this.migrationService.getTeamReport().subscribe(teams => {
      this.teams = teams;
      this.totalTeamCount = teams.count;
      if (this.totalTeamCount > this.teamOffset + 200) {
        this.loadTeamNext = true;
      }
      if (this.teamOffset >= 200) {
        this.loadTeamPrevious = true;
      }
      this.teamCount = this.teams.length;
      this.teamReportList = new MatTableDataSource(this.teams);
      this.teamReportList.sort = this.teamSort;
      this.teamReportList.paginator = this.teamPaginator;
    });
  }

}